import { defineMessages } from 'react-intl'

const messages = {
  printerNotDisconnected: {
    id: 'app.toasts.printer-not-disconnected',
    defaultMessage: 'Printer is not disconnected',
  },
  textNotPrinting: {
    id: 'app.toasts.text-not-printing',
    defaultMessage: 'Text is not printing',
  },
  printerNotConnected: {
    id: 'app.toasts.printer-not-connected',
    defaultMessage: 'Printer is not connected',
  },
  bluetoothDisabled: {
    id: 'app.toasts.bluetooth-disabled',
    defaultMessage: 'Please enable bluetooth',
  },
  printerStatusUnknown: {
    id: 'app.toasts.printer-status-unknown',
    defaultMessage: 'Unknown printer status',
  },
  pdfLabelDownloaded: {
    id: 'app.toasts.pdf-label-downloaded',
    defaultMessage: 'PDF label downloaded. Please open and print the downloaded file.',
  },
  printerPermissionDenied: {
    id: 'app.toasts.printer-permission-denied',
    defaultMessage: 'Permission to use the printer was denied. Please allow it and try again.',
  },
  printerDeviceNotFound: {
    id: 'app.toasts.printer-device-not-found',
    defaultMessage: 'The selected printer was not found. Check that it is switched on and connected, or choose another one in the menu.',
  },
  nativePdfPrintUnavailable: {
    id: 'app.toasts.native-pdf-print-unavailable',
    defaultMessage: 'This app version cannot print PDF labels. Please update the app, or switch the label format back to the label printer in the menu.',
  },
  bluetoothPrinterUnavailable: {
    id: 'app.toasts.bluetooth-printer-unavailable',
    defaultMessage: 'No Bluetooth label printer is available here. Please switch the label format to PDF in the menu.',
  },
  printError: {
    id: 'app.toasts.print-error',
    defaultMessage: 'Print Error: {error}',
  },
  printErrorUnknown: {
    id: 'app.toasts.print-error-unknown',
    defaultMessage: 'Unknown error',
  },
}

export default defineMessages(messages)
